import { useState, useEffect } from "react";
import "./DungeonStyles.css";
import { formatNumber } from "./Functions";

export const DungeonHpBar = ({ hpNow, hp }) => {
  const [percentHp, setPercentHp] = useState(100);

  useEffect(() => {
    const currentPercentage = () => {
      return (100 / hp) * hpNow;
    };
    setPercentHp(currentPercentage());
  }, [hp, hpNow]);

  // Определяем цвет полоски в зависимости от процента HP
  const getHpColor = () => {
    if (percentHp < 30) {
      return "red"; // Меньше 20% — красный
    } else if (percentHp < 65) {
      return "orange"; // Меньше 70% — оранжевый
    } else {
      return "green"; // В остальных случаях — зеленый
    }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="hp-text">
        {formatNumber(hpNow)}/{formatNumber(hp)}
      </div>

      <div className="hp-container">
        <div
          style={{
            backgroundColor: getHpColor(), // Динамический цвет
            width: `${percentHp}%`,
          }}
          className="hp-current"
        ></div>
      </div>
    </div>
  );
};
